/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Content } from './Content';
import { ContentFromJSON, ContentFromJSONTyped, ContentToJSON } from './Content';
import type { Title } from './Title';
import { TitleFromJSON, TitleFromJSONTyped, TitleToJSON } from './Title';
import type { Type } from './Type';
import { TypeFromJSON, TypeFromJSONTyped, TypeToJSON } from './Type';

/**
 *
 * @export
 * @interface ProjectUpdateModel
 */
export interface ProjectUpdateModel {
    /**
     *
     * @type {Title}
     * @memberof ProjectUpdateModel
     */
    title?: Title;
    /**
     *
     * @type {Content}
     * @memberof ProjectUpdateModel
     */
    content?: Content;
    /**
     *
     * @type {Type}
     * @memberof ProjectUpdateModel
     */
    type?: Type;
}

/**
 * Check if a given object implements the ProjectUpdateModel interface.
 */
export function instanceOfProjectUpdateModel(value: object): boolean {
    return true;
}

export function ProjectUpdateModelFromJSON(json: any): ProjectUpdateModel {
    return ProjectUpdateModelFromJSONTyped(json, false);
}

export function ProjectUpdateModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ProjectUpdateModel {
    if (json == null) {
        return json;
    }
    return {
        title: json['title'] == null ? undefined : TitleFromJSON(json['title']),
        content: json['content'] == null ? undefined : ContentFromJSON(json['content']),
        type: json['type'] == null ? undefined : TypeFromJSON(json['type']),
    };
}

export function ProjectUpdateModelToJSON(value?: ProjectUpdateModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        title: TitleToJSON(value['title']),
        content: ContentToJSON(value['content']),
        type: TypeToJSON(value['type']),
    };
}
